
































import { parseFloatNumber } from '../../utils';
import SimpleTable from '../../../core/components/SimpleTable.vue';
import { Component, Prop, Provide, Mixins, Emit, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { GetterType } from '../../../../store';
import { RootStoreHelper } from '../../mixins';

@Component({
    components: {
        SimpleTable
    }
})
export default class StatsTravelContent extends Mixins(RootStoreHelper) {
    title: string = 'Estadísticas del recorrido: ';
    noDataMsg: string = 'No hay datos disponibles';
    @Prop() tooltip: boolean;
    @Prop() visible: boolean;
    @Prop() headers: any;
    @Prop() items: any;
    @Prop() vehicles: any;
    responseIsEmpty: boolean = false;

    @Getter(GetterType.HISTORICAL_DATA_BY_PARAMETERS_STATS_FOR_REFRESH_TABLE)
    $_getHistoricalDataByParametersStatsForRefreshTable: any;

    get loading() {
        return this.$_getPendingRequest;
    }

    @Watch('$_getPendingRequest')
    showTableInPendingRequest() {
        this.responseIsEmpty = false;
    }
}
